import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45f7d49e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0.8rem"} }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item-user" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "one-hide desc" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总请客数：", -1))
const _hoisted_7 = { class: "one-hide desc" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "剩余请客数：", -1))
const _hoisted_9 = { class: "one-hide desc" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "限购次数：", -1))
const _hoisted_11 = { class: "one-hide desc" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "超级会员价格：", -1))
const _hoisted_13 = { style: {"color":"#fbb20a"} }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "price" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "分享明细 >", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
      finished: _ctx.finished,
      "finished-text": _ctx.list.length ? '没有更多了' : '暂无明细',
      error: _ctx.error,
      "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
      "error-text": "请求失败，点击重新加载",
      onLoad: _ctx.req_items
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.orderCode,
            class: "item-con cls-flex",
            onClick: ($event: any) => (_ctx.item_click(item))
          }, [
            _createVNode(_component_van_image, {
              src: item.thumb,
              width: "6rem",
              height: "7rem",
              radius: "5px"
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.packageName), 1),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(item.maxReceiveNum), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(item.surplusReceiveNum), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(item.limitNum), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, "￥" + _toDisplayString(item.shareholderPrice), 1)
              ]),
              _createElementVNode("div", {
                class: "cls-con",
                onClick: _withModifiers(($event: any) => (_ctx.detail_click(item)), ["stop"])
              }, [
                _createElementVNode("div", _hoisted_15, "￥" + _toDisplayString(item.packagePrice), 1),
                _hoisted_16
              ], 8, _hoisted_14)
            ])
          ], 8, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "finished-text", "error", "onLoad"])
  ]))
}